import { render, staticRenderFns } from "./ReferansTanimla.vue?vue&type=template&id=160935e9&scoped=true&"
import script from "./ReferansTanimla.vue?vue&type=script&lang=js&"
export * from "./ReferansTanimla.vue?vue&type=script&lang=js&"
import style0 from "./ReferansTanimla.vue?vue&type=style&index=0&id=160935e9&scoped=true&lang=css&"
import style1 from "./ReferansTanimla.vue?vue&type=style&index=1&id=160935e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160935e9",
  null
  
)

export default component.exports